import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotesListComponent } from './list/notes-list.component';
import { CreateNotesComponent } from './create/create-note.component';
import { NoteService } from './note.service';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { InlineEditorModule } from '@qontu/ngx-inline-editor';
import { NgxSmartModalModule } from 'ngx-smart-modal';

@NgModule({
  imports: [
    CommonModule,
    SweetAlert2Module,
    FormsModule,
    NgxSmartModalModule,
    InlineEditorModule
  ],
  providers: [
    NoteService
  ],
  declarations: [
    NotesListComponent,
    CreateNotesComponent
  ],
  exports: [
    NotesListComponent,
    CreateNotesComponent
  ],

})
export class NotesModule { }



// WEBPACK FOOTER //
// ./client/app/shared/notes/notes.module.ts